import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Shift } from '../roster.component';

export interface DeleteShiftDialogData {
  shift: Shift;
}

@Component({
  selector: 'app-delete-shift-dialog',
  template: `
    <h2 mat-dialog-title>Delete Option</h2>
    <mat-dialog-content>
      <p>Are you sure you want to delete?</p>
      
      <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 16px;">
        <mat-checkbox *ngIf="hasShift" [(ngModel)]="deleteShift">Delete Shift</mat-checkbox>
        <mat-checkbox *ngIf="hasAttendance" [(ngModel)]="deleteAttendance">Delete Attendance</mat-checkbox>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="!deleteShift && !deleteAttendance">Delete</button>
    </mat-dialog-actions>
  `,
  standalone: false
})
export class DeleteShiftDialogComponent {
  deleteShift = false;
  deleteAttendance = false;
  
  hasShift = false;
  hasAttendance = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteShiftDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteShiftDialogData
  ) {
    const s = data.shift;
    
    this.hasShift = !s.is_unscheduled;
    this.hasAttendance = !!s.act_shift_start_time || !!s.attendance_id;

    // Default selections based on what exists
    if (this.hasShift) {
        this.deleteShift = true;
    }
    if (this.hasAttendance) {
        this.deleteAttendance = false;
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.dialogRef.close({
      deleteShift: this.deleteShift,
      deleteAttendance: this.deleteAttendance
    });
  }
}
